import "@/App.css";
import { useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { OfflineProvider } from "@/context/OfflineContext";
import { PaywallProvider } from "@/components/Paywall";
import { AiConfirmProvider } from "@/components/AiConfirm";
import ErrorBoundary from "@/components/ErrorBoundary";
import Auth from "@/pages/Auth";
import Splash from "@/pages/Splash";
import Dashboard from "@/pages/Dashboard";
import ResetPassword from "@/pages/ResetPassword";
import VerifyEmail from "@/pages/VerifyEmail";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Privacy from "@/pages/legal/Privacy";
import Terms from "@/pages/legal/Terms";
import DeleteAccount from "@/pages/legal/DeleteAccount";
import Reviewer from "@/pages/Reviewer";
import AdminIncidents from "@/pages/AdminIncidents";

function Gate() {
  const { user, guest } = useAuth();
  const [entered, setEntered] = useState(false);
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <span className="ek-mono-label ek-pulse">DECRYPTING SESSION...</span>
      </div>
    );
  }
  if (user || guest) return <Dashboard />;
  return entered ? <Auth /> : <Splash onEnter={() => setEntered(true)} />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <OfflineProvider>
        <BrowserRouter>
          <PaywallProvider>
          <AiConfirmProvider>
          <ErrorBoundary>
          <Routes>
            <Route path="/" element={<Gate />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/delete-account" element={<DeleteAccount />} />
            <Route path="/review/:token" element={<Reviewer />} />
            <Route path="/admin/incidents" element={<AdminIncidents />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          </ErrorBoundary>
          </AiConfirmProvider>
          </PaywallProvider>
        </BrowserRouter>
        <Toaster position="top-right" theme="dark" />
        </OfflineProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
